import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";

const MentionsLegales = lazy(() => import("@/pages/MentionsLegales"));
const Confidentialite = lazy(() => import("@/pages/Confidentialite"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={
        <div style={{
          minHeight: '100vh',
          width: '100%',
          backgroundColor: '#f8fafc'
        }}
        aria-busy="true"
        aria-label="Chargement..."
        />
      }>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
